export const GET_CUSTOMER_HISTORY = "GET_CUSTOMER_HISTORY"
export const GET_CUSTOMER_HISTORY_ERR = "GET_CUSTOMER_HISTORY_ERR"

export const CLEAR_CUSTOMER_HISTORY = "CLEAR_CUSTOMER_HISTORY" 